import React, { useState, memo, useEffect, useCallback } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'

import style from './style'

function PeriodsFilter({ classes, title, onChange, items, columnName }) {
  const [date, setDate] = useState('')

  const handleDateChange = useCallback(
    e => {
      const list = [...items]
      const value = e.target.value
      setDate(value)

      if (value !== 'all') {
        const filterDataMs = value * 3600000
        const currentDateMs = new Date().getTime()
        const currentDateMinusFilterDataMS = currentDateMs - filterDataMs

        onChange(
          list.filter(
            item =>
              new Date(item.memberSince).getTime() >
              currentDateMinusFilterDataMS,
          ),
        )
      } else {
        onChange(list)
      }
    },
    [onChange, items],
  )

  useEffect(() => {
    if (!date) {
      if (columnName === 'refused') {
        // 168 hovers in one week
        handleDateChange({
          target: { value: '168' },
        })
      } else {
        handleDateChange({ target: { value: 'all' } })
      }
    } else {
      handleDateChange({ target: { value: date } })
    }
  }, [items])

  return (
    <div className={classes.filter}>
      <FormControl variant="outlined">
        <InputLabel>{title}</InputLabel>
        <Select value={date} onChange={handleDateChange}>
          <MenuItem value="168">1 week ago</MenuItem>
          <MenuItem value="336">2 week ago</MenuItem>
          <MenuItem value="504">3 week ago</MenuItem>
          <MenuItem value="672">4 week ago</MenuItem>
          <MenuItem value="840">5 week ago</MenuItem>
          <MenuItem value="all">all</MenuItem>
        </Select>
      </FormControl>
    </div>
  )
}

export default memo(withStyles(style)(PeriodsFilter))



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/ColumnHeader/PeriodsFilter/index.js